module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_5010.60e0e7f0.png";